import React,{useEffect,useState} from 'react'
import noimg from "../Images/noimg.jpg"
import api from "../Api"


function Profile_Tour_commision() {
  const customer = JSON.parse(localStorage.getItem("franchise_customer"));
  console.log("customer of Franchise", customer);
  const [ tour_commission,setTour_commission] = useState([]);
  const token = localStorage.getItem("accessToken");
  const [franchiseBooking,SetFranchiseBooking]= useState([]);
  

  useEffect(()=>{
    const fetchProfile_commission = async()=>{
      try{

      
      if(!token){
        return ;
      }
      const response = await api.get(`/admin/franchise-commissions/${customer?.franchise_details?.id}`,{
       headers :{
        Authorization : `Bearer ${token}`
       }
      })
      console.log("the response from tour commission page is ", response?.data);
      SetFranchiseBooking(response?.data?.ledger)
      }catch(err){
        console.log(err);
      }
    }
    fetchProfile_commission();
  },[])

const  franchiseBookingTour = franchiseBooking.filter(item => item?.module === "transport");

  return (
    <div className='Profile_Tour_commision'>
      <div style={{ display: "flex", justifyContent: "space-between", maxWidth: "900px", margin: "auto" }}>
        <span style={{ fontWeight: "700", color: "green" }}>Approved Commission : </span>
        <span style={{ fontWeight: "700", color: "green" }}>{customer?.transport_commission || 0}%</span>
      </div>

      
{
  franchiseBookingTour.length>0 &&(
<div style={{marginTop:"3rem"}}>
    {
      franchiseBookingTour.map((item)=>(
              <div className="commission-card" style={{marginTop:"1rem"}}>
        {/* LEFT IMAGE */}
        <div className="commission-card-img">
          <img
            src={noimg}
            alt="Tour"
          />
        </div>

        {/* CENTER DETAILS */}
        <div className="commission-card-details">
          <h4 className="commission-title">{item?.booking_details?.title}</h4>
          <p className="commission-text">
            <strong>Type:</strong> transport
          </p>
          <p className="commission-text">
            <strong>Booking Date:</strong> {item?.created_at}
          </p>
        </div>

        {/* RIGHT INFO */}
        <div className="commission-card-meta">
          <p className="commission-amount">Commission Amount: ₹{item?.commission_amount}</p>
          <span className={`commission-status ${item?.due_amount === 0 ? "paid": "pending"}`}>{item?.due_amount === 0 ? "Paid": "Pending"}</span>
          <p className="commission-date">{item?.created_at}</p>
        </div>
      </div>
      ))
    }
   </div>
  )
}




     


    </div>
  )
}

export default Profile_Tour_commision